{
  "ancillaries": {
    "bundle": {
      "conflictingBundle": "Et voi muokata lentoa tässä näkymässä, koska matkalle on valittu ",
      "unavailableBundle": "Tälle lennolle ja matkustajalle ei ole tarjolla komboa.",
      "quotaReached": "Enimmäismäärä kombo-tarjouksia on valittu. Enempää komboja ei voi lisätä.",
      "toggle": {
        "titles": {
          "seatWifi": "",
          "seatPriority": "",
          "seatCabinBaggage": "",
          "seatMeal": ""
        },
        "descriptions": {
          "seatWifi": "",
          "seatPriority": "",
          "seatCabinBaggage": "",
          "seatMeal": ""
        },
        "buttonText": {
          "showCombos": "Näytä kombotarjoukset",
          "showingCombos": "Kombotarjoukset näkyvissä",
          "comboAdded": "Lisätty",
          "addForPrice": "Lisää hintaan {price}"
        }
      },
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      }
    },
    "seatMeal": {
      "extraTitle": "Istuinpaikka + Ateria Combo",
      "offersToggle": {
        "title": {
          "seatHotPreOrderMeal": "10% alennusta kun listäät istuinpaikan ja aterian yhdessä",
          "seatFreshMeal": "10% alennusta kun listäät istuinpaikan ja aterian yhdessä"
        },
        "description": {
          "seatHotPreOrderMeal": "Valisemasi istuinpaikka + Savoury chicken & drink meal (chicken breast with caponata and spinach tagliatelle)",
          "seatFreshMeal": "Valisemasi istuinpaikka + Northern Choice meal (smoothie, salmon rye sandwich, chocolate, coffee or tea)"
        }
      },
      "selectedToggle": {
        "title": {
          "seatHotPreOrderMeal": "10% alennusta kun lisäät istuinpaikan ateriasi kanssa",
          "seatFreshMeal": "10% alennusta kun lisäät istuinpaikan ateriasi kanssa"
        },
        "description": {
          "seatHotPreOrderMeal": "Maukas kana & drink meal (chicken breast with caponata and spinach tagliatelle)",
          "seatFreshMeal": "Pohjoinen valinta meal (smoothie, salmon rye sandwich, chocolate, coffee or tea)"
        }
      }
    },
    "seatPriority": {
      "extraTitle": "Istuinpaikka + Priority Combo",
      "offersToggle": {
        "title": {
          "seatPriorityServices": "10% alennusta kun lisäät istuinpaikan ja priority palvelut yhdessä"
        },
        "description": {
          "seatPriorityServices": "Valitsemasi istuinpaikka + Access to priority check-in and security"
        }
      },
      "selectedToggle": {
        "title": {
          "seatPriorityServices": "10% alennusta kun lisäät priority palvelut istuinpaikkaasi"
        },
        "description": {
          "seatPriorityServices": "Pääsy erityiseen priority check-iniin ja security lane"
        }
      }
    },
    "seatWifi": {
      "extraTitle": "Istuinpaikka + Internet Combo",
      "offersToggle": {
        "title": {
          "seatWifi": "10% alennusta kun lisäät istuinpaikan ja wifin yhdessä"
        },
        "description": {
          "seatWifi": "Valitsemasi istuinpaikka + Stream package for the entire flight"
        }
      },
      "selectedToggle": {
        "title": {
          "seatWifi": "10% alennusta kun lisäät internetin istuinpaikkaasi"
        },
        "description": {
          "seatWifi": "Stream paketti koko lennolle"
        }
      }
    },
    "seatCabinBaggage": {
      "extraTitle": "Istuinpaikka + Käsimatkatavara Combo",
      "offersToggle": {
        "title": {
          "seatCabinBaggage": "10% alennusta kun lisäät istuinpaikan ja käsimatkatavaran yhdessä"
        },
        "description": {
          "seatCabinBaggage": "Valitsemasi istuinpaikka + käsimatkatavara (total weight with a small bag: 8 kg)"
        }
      },
      "selectedToggle": {
        "title": {
          "seatCabinBaggage": "10% alennusta kun lisäät käsimatkatavaran istuinpaikkaasi"
        },
        "description": {
          "seatCabinBaggage": "Käsimatkatavara (55 × 40 × 23 cm). Total weight with a small bag: 8 kg."
        }
      }
    },
    "seat": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "seatCombos": {
      "noSeatCombosAvailable": "Sorry, combo offers cannot be selected online for this flight.",
      "noSeatCombosAvailableBus": "Sorry, combo offers cannot be selected in advance for the bus connection.",
      "noSeatCombosAvailableForOperatingAirline": "The flight is operated by {airline}.",
      "eligibility": {
        "notAvailableBus": "Unfortunately, combo offers <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, combo offers <b>cannot be added for this part of your journey on our site</b> because this is a train connection.",
        "boundFlown": "This flight has already departed."
      }
    },
    "meals": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "lounge": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "wifi": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "bags": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "cabinBaggage": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "pet": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "sport": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "productList": {
      "subtitle": {
        "topPick": "Suosittu valinta tälle lennolle:",
        "generic": "Valitse näistä vaihtoehdoista:",
        "added": "Olet lisännyt:"
      }
    }
  },
  "purchase": {
    "payment": {
      "seatMealCount": "Combot x {bundleCount}",
      "seatPriorityCount": "Combot x {bundleCount}",
      "seatWifiCount": "Combot x {bundleCount}",
      "seatCabinBaggageCount": "Combot x {bundleCount}",
      "bundleCount": ""
    }
  },
  "upsellCard": {
    "description": {
      "genericLongHaul": "Compare the meal service, seats and entertainment in different travel classes on long-haul flights."
    },
    "modalLink": {
      "allClasses": "Travel class differences"
    }
  },
  "upsellPromotion": {
    "totalPriceInfo": "Hinta yhteensä kaikilta matkustajilta",
    "selected": "Valittu",
    "changeToClassic": "Vaihda Classic-lippuun",
    "continueWithLight": "Jatka Light-lipulla",
    "continueWithSuperLight": "Continue with Superlight"
  },
  "services": {
    "bundle": {
      "state": {
        "modify": {
          "ariaText": "",
          "text": ""
        },
        "purchased": {
          "default": "",
          "plural": "",
          "singular": ""
        },
        "select": {
          "ariaText": "",
          "text": ""
        },
        "selection": {
          "default": "",
          "plural": "",
          "singular": ""
        },
        "updating": {
          "ariaText": ""
        }
      }
    },
    "seatWifi": {
      "state": {
        "modify": {
          "ariaText": "Muokkaa komboja",
          "text": "Muokkaa"
        },
        "purchased": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa lisätty",
          "singular": "1 kombo lisätty"
        },
        "select": {
          "ariaText": "Valitse kombot",
          "text": "Valitse"
        },
        "selection": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa valittu",
          "singular": "1 kombo valittu"
        },
        "updating": {
          "ariaText": "Vahvistetaan kombovalintoja"
        }
      }
    },
    "seatMeal": {
      "state": {
        "modify": {
          "ariaText": "Muokkaa komboja",
          "text": "Muokkaa"
        },
        "purchased": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa lisätty",
          "singular": "1 kombo lisätty"
        },
        "select": {
          "ariaText": "Valitse kombot",
          "text": "Valitse"
        },
        "selection": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa valittu",
          "singular": "1 kombo valittu"
        },
        "updating": {
          "ariaText": "Vahvistetaan kombovalintoja"
        }
      }
    },
    "seatCabinBaggage": {
      "state": {
        "modify": {
          "ariaText": "Muokkaa komboja",
          "text": "Muokkaa"
        },
        "purchased": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa lisätty",
          "singular": "1 kombo lisätty"
        },
        "select": {
          "ariaText": "Valitse kombot",
          "text": "Valitse"
        },
        "selection": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa valittu",
          "singular": "1 kombo valittu"
        },
        "updating": {
          "ariaText": "Vahvistetaan kombovalintoja"
        }
      }
    },
    "seatPriority": {
      "state": {
        "modify": {
          "ariaText": "Muokkaa komboja",
          "text": "Muokkaa"
        },
        "purchased": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa lisätty",
          "singular": "1 kombo lisätty"
        },
        "select": {
          "ariaText": "Valitse kombot",
          "text": "Valitse"
        },
        "selection": {
          "default": "Ei valittuja komboja",
          "plural": "{numberOfItems} komboa valittu",
          "singular": "1 kombo valittu"
        },
        "updating": {
          "ariaText": "Vahvistetaan kombovalintoja"
        }
      }
    }
  },
  "stepperContinueText": {
    "travelExtras": "Siirry maksamaan"
  }
}
